import { PageLayout } from '@powerportalspro/react-fluent';
import { useT } from '@powerportalspro/react';

// Localization namespace — same JSON the Blazor demo's
// `PageLayoutMainDemo` reads from, so the two stacks share strings.
const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Layout.PageLayout.PageLayoutMainDemo';

// PageLayout normally fills the viewport. The docs page itself is already
// inside a PageLayout, so we wrap the demo in a constrained frame to
// keep it inline with the surrounding doc instead of taking over the
// whole page. Two cooperating bits make this actually work:
//
//   1. The wrapper uses a definite `height: 200` + `overflow: hidden`,
//      giving PageLayout a real parent height to anchor percentage
//      heights against.
//
//   2. PageLayout itself is forced into "fill parent" mode via inline
//      `style={{ height: '100%', minHeight: '100%' }}`. PageLayout
//      defaults to `height: 100vh; minHeight: 100vh` because nothing
//      in this sample's React tree provides a `PageLayoutNestingContext`
//      with `isNested: true` (the outer demo site is Blazor; the React
//      sample mounts at the top of its own React tree inside a custom
//      element, so the `child-layout` 100%-height treatment never fires
//      automatically). Without these inline overrides PageLayout would
//      render at ~100vh, `overflow: hidden` on the wrapper would clip
//      the bottom — including the footer — and nav/body would have
//      hundreds of pixels of room so their `overflow-y: auto` would
//      never engage.
export function PageLayoutMainSample() {
  const t = useT();
  const padStyle = { padding: '10px' };

  return (
    <div
      style={{
        height: 200,
        overflow: 'hidden',
        border: '1px solid var(--neutral-stroke-rest)',
      }}
    >
      <PageLayout
        style={{ height: '100%', minHeight: '100%' }}
        // Shown inside a frame on the docs page, so keep the side navigation on a phone
        // rather than opening a drawer over the whole page, as the Blazor sample does.
        collapseNavigationOnMobile={false}
        headerStyle={padStyle}
        bodyStyle={padStyle}
        navigationStyle={padStyle}
        footerStyle={padStyle}
        header={t(`${STRINGS_BASE}.header-label`)}
        navigation={
          <div style={{ minHeight: 400 }}>{t(`${STRINGS_BASE}.navigation-label`)}</div>
        }
        body={<div style={{ minHeight: 400 }}>{t(`${STRINGS_BASE}.body-label`)}</div>}
        footer={t(`${STRINGS_BASE}.footer-label`)}
      />
    </div>
  );
}
